// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-left-\\[40px\\]{
  left: -40px;
}
.-right-1{
  right: -0.25rem;
}
.-right-2{
  right: -0.5rem;
}
.-right-\\[40px\\]{
  right: -40px;
}
.-top-1{
  top: -0.25rem;
}
.-top-2{
  top: -0.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 0.25rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-5{
  bottom: 1.25rem;
}
.bottom-\\[3\\%\\]{
  bottom: 3%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-8{
  left: 2rem;
}
.left-\\[20\\%\\]{
  left: 20%;
}
.left-\\[35\\%\\]{
  left: 35%;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.left-\\[80\\%\\]{
  left: 80%;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-\\[12\\%\\]{
  right: 12%;
}
.right-\\[40\\%\\]{
  right: 40%;
}
.right-\\[45\\%\\]{
  right: 45%;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[75\\%\\]{
  top: 75%;
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[51\\]{
  z-index: 51;
}
.z-\\[999\\]{
  z-index: 999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-full{
  grid-column: 1 / -1;
}
.\\!mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-7{
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-ml-6{
  margin-left: -1.5rem;
}
.-ml-8{
  margin-left: -2rem;
}
.-mt-16{
  margin-top: -4rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-9{
  margin-left: 2.25rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-28{
  margin-top: 7rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-5{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-1{
  height: 0.25rem;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-24{
  height: 6rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-60{
  height: 15rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[150px\\]{
  height: 150px;
}
.h-\\[15px\\]{
  height: 15px;
}
.h-\\[180px\\]{
  height: 180px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[230px\\]{
  height: 230px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30vh\\]{
  height: 30vh;
}
.h-\\[320px\\]{
  height: 320px;
}
.h-\\[350px\\]{
  height: 350px;
}
.h-\\[370px\\]{
  height: 370px;
}
.h-\\[380px\\]{
  height: 380px;
}
.h-\\[3rem\\]{
  height: 3rem;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[550px\\]{
  height: 550px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[80vh\\]{
  height: 80vh;
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-screen{
  height: 100vh;
}
.min-h-28{
  min-height: 7rem;
}
.min-h-48{
  min-height: 12rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-96{
  min-height: 24rem;
}
.min-h-\\[100vh\\]{
  min-height: 100vh;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[27rem\\]{
  min-height: 27rem;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[700px\\]{
  min-height: 700px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-28{
  width: 7rem;
}
.w-3{
  width: 0.75rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-\\[10px\\]{
  width: 10px;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[125px\\]{
  width: 125px;
}
.w-\\[145px\\]{
  width: 145px;
}
.w-\\[160px\\]{
  width: 160px;
}
.w-\\[170px\\]{
  width: 170px;
}
.w-\\[180px\\]{
  width: 180px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[20rem\\]{
  width: 20rem;
}
.w-\\[23rem\\]{
  width: 23rem;
}
.w-\\[250px\\]{
  width: 250px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[40px\\]{
  width: 40px;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[70px\\]{
  width: 70px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[75px\\]{
  width: 75px;
}
.w-\\[80\\%\\]{
  width: 80%;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.min-w-0{
  min-width: 0px;
}
.min-w-16{
  min-width: 4rem;
}
.min-w-\\[2rem\\]{
  min-width: 2rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-\\[1000px\\]{
  max-width: 1000px;
}
.max-w-\\[100vw\\]{
  max-width: 100vw;
}
.max-w-\\[1050px\\]{
  max-width: 1050px;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[1250px\\]{
  max-width: 1250px;
}
.max-w-\\[1350px\\]{
  max-width: 1350px;
}
.max-w-\\[330px\\]{
  max-width: 330px;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[450px\\]{
  max-width: 450px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[650px\\]{
  max-width: 650px;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[700px\\]{
  max-width: 700px;
}
.max-w-\\[76rem\\]{
  max-width: 76rem;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.table-auto{
  table-layout: auto;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-y-4{
  --tw-border-spacing-y: 1rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-right{
  transform-origin: right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full{
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-10{
  --tw-translate-x: 2.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2{
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.list-disc{
  list-style-type: disc;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-rows-\\[auto\\2c 1px\\2c auto\\2c 1px\\2c auto\\]{
  grid-template-rows: auto 1px auto 1px auto;
}
.grid-rows-\\[auto_auto_auto\\]{
  grid-template-rows: auto auto auto;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-items-center{
  justify-items: center;
}
.gap-0{
  gap: 0px;
}
.gap-1{
  gap: 0.25rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-8{
  gap: 2rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[0px\\]{
  border-radius: 0px;
}
.rounded-\\[1\\.75rem\\]{
  border-radius: 1.75rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[17px\\]{
  border-radius: 17px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[6px\\]{
  border-radius: 6px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-l-md{
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-xl{
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-md{
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-r-xl{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.rounded-br-\\[10px\\]{
  border-bottom-right-radius: 10px;
}
.rounded-tr-\\[10px\\]{
  border-top-right-radius: 10px;
}
.rounded-tr-md{
  border-top-right-radius: 0.375rem;
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[6px\\]{
  border-width: 6px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-solid{
  border-style: solid;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#1a1a1a\\]{
  --tw-border-opacity: 1;
  border-color: rgb(26 26 26 / var(--tw-border-opacity, 1));
}
.border-\\[\\#A0AEC0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D9DCB0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 220 176 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E1E1E1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(225 225 225 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EBE8FF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(235 232 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ECE8CE\\]{
  --tw-border-opacity: 1;
  border-color: rgb(236 232 206 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFFFFF\\]{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d9dab2\\]{
  --tw-border-opacity: 1;
  border-color: rgb(217 218 178 / var(--tw-border-opacity, 1));
}
.border-aths{
  --tw-border-opacity: 1;
  border-color: rgb(236 232 206 / var(--tw-border-opacity, 1));
}
.border-bgprimary{
  --tw-border-opacity: 1;
  border-color: rgb(217 220 176 / var(--tw-border-opacity, 1));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-bordercolor{
  --tw-border-opacity: 1;
  border-color: rgb(235 232 255 / var(--tw-border-opacity, 1));
}
.border-dark{
  --tw-border-opacity: 1;
  border-color: rgb(37 35 27 / var(--tw-border-opacity, 1));
}
.border-darkGreen{
  --tw-border-opacity: 1;
  border-color: rgb(93 115 60 / var(--tw-border-opacity, 1));
}
.border-normalGray{
  --tw-border-opacity: 1;
  border-color: rgb(121 125 140 / var(--tw-border-opacity, 1));
}
.border-orange{
  --tw-border-opacity: 1;
  border-color: rgb(255 146 64 / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-aths{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 232 206 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0000005E\\]{
  background-color: #0000005E;
}
.bg-\\[\\#25231B80\\]{
  background-color: #25231B80;
}
.bg-\\[\\#5D733C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(93 115 60 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D9DCB0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 220 176 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5E7EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECE8CE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 232 206 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F0D23C\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(240 210 60 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2D53F\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(242 213 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F96767\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 103 103 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F9F9F9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9dab2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 218 178 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e9ecd7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 215 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#edeccf\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(237 236 207 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f9f9f9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff9f5a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 90 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffde59\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 222 89 / var(--tw-bg-opacity, 1));
}
.bg-aths{
  --tw-bg-opacity: 1;
  background-color: rgb(236 232 206 / var(--tw-bg-opacity, 1));
}
.bg-bgprimary{
  --tw-bg-opacity: 1;
  background-color: rgb(217 220 176 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-buttoncolor{
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 215 / var(--tw-bg-opacity, 1));
}
.bg-dark{
  --tw-bg-opacity: 1;
  background-color: rgb(37 35 27 / var(--tw-bg-opacity, 1));
}
.bg-errorcolor{
  --tw-bg-opacity: 1;
  background-color: rgb(229 32 32 / var(--tw-bg-opacity, 1));
}
.bg-green{
  --tw-bg-opacity: 1;
  background-color: rgb(90 115 60 / var(--tw-bg-opacity, 1));
}
.bg-lightgreen{
  background-color: #ECE8CE54;
}
.bg-orange{
  --tw-bg-opacity: 1;
  background-color: rgb(255 146 64 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-700{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.bg-tablecolor{
  --tw-bg-opacity: 1;
  background-color: rgb(229 233 219 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-30{
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40{
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.\\!bg-cover{
  background-size: cover !important;
}
.\\!bg-bottom{
  background-position: bottom !important;
}
.\\!bg-center{
  background-position: center !important;
}
.\\!bg-no-repeat{
  background-repeat: no-repeat !important;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-fill{
  object-fit: fill;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[2px\\]{
  padding: 2px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-\\[2px\\]{
  padding-top: 2px;
  padding-bottom: 2px;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-16{
  padding-left: 4rem;
}
.pl-28{
  padding-left: 7rem;
}
.pl-4{
  padding-left: 1rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-16{
  padding-right: 4rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-14{
  padding-top: 3.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-24{
  padding-top: 6rem;
}
.pt-\\[70px\\]{
  padding-top: 70px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-\\[\\'Quicksand\\'\\]{
  font-family: 'Quicksand';
}
.font-\\[\\'Roboto_Mono\\'\\]{
  font-family: 'Roboto Mono';
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-quicksand{
  font-family: "Quicksand", sans-serif;
}
.font-roboto-mono{
  font-family: "Roboto Mono", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[1\\.8rem\\]{
  font-size: 1.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[1rem\\]{
  font-size: 1rem;
}
.text-\\[2\\.5rem\\]{
  font-size: 2.5rem;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[25px\\]{
  font-size: 25px;
}
.text-\\[30px\\]{
  font-size: 30px;
}
.text-\\[40px\\]{
  font-size: 40px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.leading-\\[18\\.75px\\]{
  line-height: 18.75px;
}
.leading-\\[31\\.65px\\]{
  line-height: 31.65px;
}
.tracking-\\[6\\%\\]{
  letter-spacing: 6%;
}
.text-\\[\\#10182B\\]{
  --tw-text-opacity: 1;
  color: rgb(16 24 43 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F2937AB\\]{
  color: #1F2937AB;
}
.text-\\[\\#1F2937\\]{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1a1a\\]{
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A6741\\]{
  --tw-text-opacity: 1;
  color: rgb(74 103 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff6b35\\]{
  --tw-text-opacity: 1;
  color: rgb(255 107 53 / var(--tw-text-opacity, 1));
}
.text-bgprimary{
  --tw-text-opacity: 1;
  color: rgb(217 220 176 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-dark{
  --tw-text-opacity: 1;
  color: rgb(37 35 27 / var(--tw-text-opacity, 1));
}
.text-darkGreen{
  --tw-text-opacity: 1;
  color: rgb(93 115 60 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-errorcolor{
  --tw-text-opacity: 1;
  color: rgb(229 32 32 / var(--tw-text-opacity, 1));
}
.text-gray{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-graylight{
  --tw-text-opacity: 1;
  color: rgb(113 128 150 / var(--tw-text-opacity, 1));
}
.text-green{
  --tw-text-opacity: 1;
  color: rgb(90 115 60 / var(--tw-text-opacity, 1));
}
.text-lightgray{
  --tw-text-opacity: 1;
  color: rgb(135 142 165 / var(--tw-text-opacity, 1));
}
.text-normalGray{
  --tw-text-opacity: 1;
  color: rgb(121 125 140 / var(--tw-text-opacity, 1));
}
.text-orange{
  --tw-text-opacity: 1;
  color: rgb(255 146 64 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.opacity-0{
  opacity: 0;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-75{
  opacity: 0.75;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300{
  transition-duration: 300ms;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    background: #ECE8CE;
}

.img_div img {
    width: 160px;
    height: 130px;
    object-fit: cover;
    clip-path: polygon(10% 20%, 80% 0%, 100% 100%, 0 79%);
}

.filter_section input:active,
.filter_section input:focus {
    border: 1px solid #25231B !important;
    border-radius: 8px !important;
    outline: none !important;
}

.filter_section select:active,
.filter_section select:focus {
    border: 1px solid #25231B !important;
    border-radius: 8px !important;
    outline: none !important;
}

.errorMsg {
    color: red;
    font-size: 12px;
    font-weight: 400;
}

.terms-conditions,
.privacy-policy {
    margin: auto;
    padding: 70px 16px;
    max-width: 1350px;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    color: #333;
}

.terms-conditions h1,
.privacy-policy h1 {
    font-family: Roboto Mono;
    font-size: 40px;
    font-style: italic;
    font-weight: 700;
    line-height: 52.75px;
    letter-spacing: 0.06em;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-bottom: 15px;
    color: #25231B;
}

.terms-conditions h2,
.privacy-policy h2 {
    font-family: Roboto Mono;
    font-size: 30px;
    font-style: italic;
    font-weight: 700;
    line-height: 52.75px;
    letter-spacing: 0.06em;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 15px;
    color: #25231B;
}

.terms-conditions p,
.privacy-policy p {
    font-family: Quicksand;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.06em;
    /* text-align: cente/r; */
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 10px 0;
    color: #25231B;
}

.card_icons svg {
    width: 18px;
    height: 18px;
}

.cards_icon_world svg {
    width: 30px !important;
    height: 30px !important;
}

@media screen and (max-width:768px) {
    .card_icons svg {
        width: 14px;
        height: 14px;
    }
}


::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

::-webkit-scrollbar-thumb {
    background: #D9DCB0;
    /* Scrollbar thumb color */
    border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* Thumb hover color */
    cursor: pointer;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* Track color */
}

/* For Firefox */
* {
    scrollbar-width: thin;
    scrollbar-color: #D9DCB0 #f1f1f1;
    /* Thumb and track colors */
}


.Toastify__toast-container {
    font-family: 'Poppins', sans-serif;
    max-width: 500px;
}

/* Customizing the toast notification */
.Toastify__toast {
    background-color: #ECE8CE !important;
    color: #25231B !important;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

/* Customizing the success toast */
.Toastify__toast--success {
    background-color: #ECE8CE !important;
    color: #25231B !important;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid green !important;
}

/* Customizing the error toast */
.Toastify__toast--error {
    background-color: #ECE8CE !important;
    color: #25231B !important;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
    border: 1px solid red !important;
}





.toast-success .toastify__toast-icon {
    color: #25231B;
    /* Set the desired color */
}

.input_divs .react-select__control {
    height: 43px !important;
    background: #ECE8CE !important;
    border: none !important;
}




.crop-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    top: 80px;
    width: 100%;
    height: 100%;
}

.reactEasyCrop_Container {
    height: 400px !important;
}

.controls {
    position: absolute;
    bottom: 80px;
    left: 50%;
    width: 50%;
    transform: translateX(-50%);
    height: 40px;
    display: flex;
    align-items: center;
}

.slider {
    padding: 22px 0px;
}

.zoom-range {
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 2px;
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    background: #ECA45B;
    width: 100%;
}

.zoom-range::-moz-range-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #ECA45B;
    background: #ECA45B;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    -moz-transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.zoom-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid #ECA45B;
    background: #ECA45B;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    -webkit-transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.controls:hover input[type='range']::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);
    border-radius: 50%;
}

.controls:hover input[type='range']::-moz-range-thumb {
    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);
}

.thumb_nail_clip {
    clip-path: polygon(0 0, 100% 0%, 100% 96%, 0 74%);
}

#react-select-12-placeholder {
    color: #25231B !important;
    font-family: "Quicksand", sans-serif !important;
    font-weight: 700 !important;
}

.placeholder\\:text-\\[\\#CDD0D4\\]::placeholder{
  --tw-text-opacity: 1;
  color: rgb(205 208 212 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-dark::placeholder{
  --tw-text-opacity: 1;
  color: rgb(37 35 27 / var(--tw-text-opacity, 1));
}

.after\\:block::after{
  content: var(--tw-content);
  display: block;
}

.after\\:h-\\[100px\\]::after{
  content: var(--tw-content);
  height: 100px;
}

.after\\:w-\\[170px\\]::after{
  content: var(--tw-content);
  width: 170px;
}

.after\\:translate-x-\\[-50\\%\\]::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:scale-x-\\[2\\]::after{
  content: var(--tw-content);
  --tw-scale-x: 2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-\\[100\\%\\]::after{
  content: var(--tw-content);
  border-radius: 100%;
}

.after\\:bg-aths::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(236 232 206 / var(--tw-bg-opacity, 1));
}

.after\\:bg-bgprimary::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(217 220 176 / var(--tw-bg-opacity, 1));
}

.after\\:bg-orange::after{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 146 64 / var(--tw-bg-opacity, 1));
}

.after\\:opacity-100::after{
  content: var(--tw-content);
  opacity: 1;
}

.after\\:content-\\[\\'\\'\\]::after{
  --tw-content: '';
  content: var(--tw-content);
}

.hover\\:cursor-pointer:hover{
  cursor: pointer;
}

.hover\\:bg-\\[\\#d4d8a8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(212 216 168 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-bgprimary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(217 220 176 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-buttoncolor:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 236 215 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-dark:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 35 27 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-tablecolor:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 233 219 / var(--tw-bg-opacity, 1));
}

.hover\\:font-roboto-mono:hover{
  font-family: "Roboto Mono", monospace;
}

.hover\\:font-bold:hover{
  font-weight: 700;
}

.hover\\:text-black:hover{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.focus\\:border-\\[\\#D9DCB0\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(217 220 176 / var(--tw-border-opacity, 1));
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.active\\:border-\\[\\#D9DCB0\\]:active{
  --tw-border-opacity: 1;
  border-color: rgb(217 220 176 / var(--tw-border-opacity, 1));
}

.active\\:outline-none:active{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.group:hover .group-hover\\:visible{
  visibility: visible;
}

.group:hover .group-hover\\:block{
  display: block;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

@media (min-width: 640px){
  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:mt-4{
    margin-top: 1rem;
  }
  .sm\\:mt-6{
    margin-top: 1.5rem;
  }
  .sm\\:mt-8{
    margin-top: 2rem;
  }
  .sm\\:h-12{
    height: 3rem;
  }
  .sm\\:h-5{
    height: 1.25rem;
  }
  .sm\\:h-6{
    height: 1.5rem;
  }
  .sm\\:h-\\[180px\\]{
    height: 180px;
  }
  .sm\\:h-\\[220px\\]{
    height: 220px;
  }
  .sm\\:w-5{
    width: 1.25rem;
  }
  .sm\\:w-6{
    width: 1.5rem;
  }
  .sm\\:w-\\[200px\\]{
    width: 200px;
  }
  .sm\\:w-\\[220px\\]{
    width: 220px;
  }
  .sm\\:w-auto{
    width: auto;
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-end{
    justify-content: flex-end;
  }
  .sm\\:gap-0{
    gap: 0px;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-5{
    gap: 1.25rem;
  }
  .sm\\:gap-6{
    gap: 1.5rem;
  }
  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }
  .sm\\:self-auto{
    align-self: auto;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px){
  .md\\:static{
    position: static;
  }
  .md\\:absolute{
    position: absolute;
  }
  .md\\:relative{
    position: relative;
  }
  .md\\:bottom-2{
    bottom: 0.5rem;
  }
  .md\\:bottom-\\[2\\%\\]{
    bottom: 2%;
  }
  .md\\:bottom-\\[30\\%\\]{
    bottom: 30%;
  }
  .md\\:left-\\[15\\%\\]{
    left: 15%;
  }
  .md\\:left-\\[40\\%\\]{
    left: 40%;
  }
  .md\\:left-\\[5\\%\\]{
    left: 5%;
  }
  .md\\:left-\\[60\\%\\]{
    left: 60%;
  }
  .md\\:right-\\[10\\%\\]{
    right: 10%;
  }
  .md\\:right-\\[40\\%\\]{
    right: 40%;
  }
  .md\\:right-\\[5\\%\\]{
    right: 5%;
  }
  .md\\:top-\\[15\\%\\]{
    top: 15%;
  }
  .md\\:top-\\[20\\%\\]{
    top: 20%;
  }
  .md\\:top-\\[35\\%\\]{
    top: 35%;
  }
  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }
  .md\\:col-span-5{
    grid-column: span 5 / span 5;
  }
  .md\\:my-0{
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .md\\:-mt-20{
    margin-top: -5rem;
  }
  .md\\:mb-0{
    margin-bottom: 0px;
  }
  .md\\:ml-64{
    margin-left: 16rem;
  }
  .md\\:ml-\\[4rem\\]{
    margin-left: 4rem;
  }
  .md\\:mt-0{
    margin-top: 0px;
  }
  .md\\:mt-1{
    margin-top: 0.25rem;
  }
  .md\\:mt-16{
    margin-top: 4rem;
  }
  .md\\:mt-32{
    margin-top: 8rem;
  }
  .md\\:mt-\\[15rem\\]{
    margin-top: 15rem;
  }
  .md\\:mt-\\[4rem\\]{
    margin-top: 4rem;
  }
  .md\\:block{
    display: block;
  }
  .md\\:inline{
    display: inline;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:hidden{
    display: none;
  }
  .md\\:h-10{
    height: 2.5rem;
  }
  .md\\:h-\\[1050px\\]{
    height: 1050px;
  }
  .md\\:h-\\[1100px\\]{
    height: 1100px;
  }
  .md\\:h-\\[1200px\\]{
    height: 1200px;
  }
  .md\\:h-\\[250px\\]{
    height: 250px;
  }
  .md\\:h-\\[270px\\]{
    height: 270px;
  }
  .md\\:h-auto{
    height: auto;
  }
  .md\\:h-full{
    height: 100%;
  }
  .md\\:h-screen{
    height: 100vh;
  }
  .md\\:min-h-\\[110vh\\]{
    min-height: 110vh;
  }
  .md\\:w-2\\/5{
    width: 40%;
  }
  .md\\:w-3\\/5{
    width: 60%;
  }
  .md\\:w-\\[250px\\]{
    width: 250px;
  }
  .md\\:w-\\[260px\\]{
    width: 260px;
  }
  .md\\:w-\\[296px\\]{
    width: 296px;
  }
  .md\\:w-\\[300px\\]{
    width: 300px;
  }
  .md\\:w-\\[350px\\]{
    width: 350px;
  }
  .md\\:w-\\[420px\\]{
    width: 420px;
  }
  .md\\:w-\\[calc\\(100\\%-16rem\\)\\]{
    width: calc(100% - 16rem);
  }
  .md\\:max-w-\\[480px\\]{
    max-width: 480px;
  }
  .md\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .md\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:justify-end{
    justify-content: flex-end;
  }
  .md\\:justify-center{
    justify-content: center;
  }
  .md\\:gap-2{
    gap: 0.5rem;
  }
  .md\\:gap-4{
    gap: 1rem;
  }
  .md\\:gap-5{
    gap: 1.25rem;
  }
  .md\\:space-x-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .md\\:whitespace-nowrap{
    white-space: nowrap;
  }
  .md\\:rounded-lg{
    border-radius: 0.5rem;
  }
  .md\\:bg-transparent{
    background-color: transparent;
  }
  .md\\:p-24{
    padding: 6rem;
  }
  .md\\:p-5{
    padding: 1.25rem;
  }
  .md\\:p-6{
    padding: 1.5rem;
  }
  .md\\:p-8{
    padding: 2rem;
  }
  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .md\\:pb-60{
    padding-bottom: 15rem;
  }
  .md\\:pl-12{
    padding-left: 3rem;
  }
  .md\\:pl-24{
    padding-left: 6rem;
  }
  .md\\:pl-4{
    padding-left: 1rem;
  }
  .md\\:pr-0{
    padding-right: 0px;
  }
  .md\\:text-right{
    text-align: right;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-\\[13px\\]{
    font-size: 13px;
  }
  .md\\:text-\\[16px\\]{
    font-size: 16px;
  }
  .md\\:text-\\[2\\.5rem\\]{
    font-size: 2.5rem;
  }
  .md\\:text-\\[20px\\]{
    font-size: 20px;
  }
  .md\\:text-\\[40px\\]{
    font-size: 40px;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px){
  .lg\\:-ml-16{
    margin-left: -4rem;
  }
  .lg\\:-mt-\\[6rem\\]{
    margin-top: -6rem;
  }
  .lg\\:h-\\[280px\\]{
    height: 280px;
  }
  .lg\\:max-w-\\[310px\\]{
    max-width: 310px;
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}

@media (min-width: 1280px){
  .xl\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,qDAAqD;AACzD;;AAEA;;IAEI,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;;IAEI,oCAAoC;IACpC,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kCAAkC;IAClC,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;IAClC,8BAA8B;IAC9B,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;;AAGA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,gCAAgC;IAChC,2BAA2B;AAC/B;;;AAGA;IACI,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,mDAAmD;AACvD;;AAEA,kCAAkC;AAClC;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,mDAAmD;IACnD,kCAAkC;AACtC;;AAEA,gCAAgC;AAChC;IACI,oCAAoC;IACpC,yBAAyB;IACzB,mBAAmB;IACnB,mDAAmD;IACnD,gCAAgC;AACpC;;;;;;AAMA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,uBAAuB;AAC3B;;;;;AAKA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kEAA6D;IAA7D,6DAA6D;AACjE;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qEAA6D;IAA7D,6DAA6D;AACjE;;AAEA;IACI,mDAAmD;IACnD,kBAAkB;AACtB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;IAC/C,2BAA2B;AAC/B;;AA7QA;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD,sBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD,eA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,0BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,gBA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,kBA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,oBA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA,sBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,8BA6QC;EA7QD;AA6QC;;AA7QD;EAAA,sBA6QC;EA7QD;AA6QC;;AA7QD;EAAA,8BA6QC;EA7QD;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;AA6QC;;AA7QD;EAAA;IAAA;EA6QC;EA7QD;IAAA,gBA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,uBA6QC;IA7QD,4DA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;EA7QD;IAAA,qBA6QC;IA7QD;EA6QC;EA7QD;IAAA,oBA6QC;IA7QD;EA6QC;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;EA7QD;IAAA,eA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;AAAA;;AA7QD;EAAA;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,eA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,qBA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,uBA6QC;IA7QD,mDA6QC;IA7QD;EA6QC;EA7QD;IAAA,uBA6QC;IA7QD,2DA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,iBA6QC;IA7QD;EA6QC;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,eA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA,mBA6QC;IA7QD;EA6QC;EA7QD;IAAA,kBA6QC;IA7QD;EA6QC;AAAA;;AA7QD;EAAA;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA;EA6QC;EA7QD;IAAA,oBA6QC;IA7QD;EA6QC;AAAA;;AA7QD;EAAA;IAAA,kBA6QC;IA7QD;EA6QC;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    background: #ECE8CE;\n}\n\n.img_div img {\n    width: 160px;\n    height: 130px;\n    object-fit: cover;\n    clip-path: polygon(10% 20%, 80% 0%, 100% 100%, 0 79%);\n}\n\n.filter_section input:active,\n.filter_section input:focus {\n    border: 1px solid #25231B !important;\n    border-radius: 8px !important;\n    outline: none !important;\n}\n\n.filter_section select:active,\n.filter_section select:focus {\n    border: 1px solid #25231B !important;\n    border-radius: 8px !important;\n    outline: none !important;\n}\n\n.errorMsg {\n    color: red;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.terms-conditions,\n.privacy-policy {\n    margin: auto;\n    padding: 70px 16px;\n    max-width: 1350px;\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    color: #333;\n}\n\n.terms-conditions h1,\n.privacy-policy h1 {\n    font-family: Roboto Mono;\n    font-size: 40px;\n    font-style: italic;\n    font-weight: 700;\n    line-height: 52.75px;\n    letter-spacing: 0.06em;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin-bottom: 15px;\n    color: #25231B;\n}\n\n.terms-conditions h2,\n.privacy-policy h2 {\n    font-family: Roboto Mono;\n    font-size: 30px;\n    font-style: italic;\n    font-weight: 700;\n    line-height: 52.75px;\n    letter-spacing: 0.06em;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin-top: 15px;\n    color: #25231B;\n}\n\n.terms-conditions p,\n.privacy-policy p {\n    font-family: Quicksand;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n    letter-spacing: 0.06em;\n    /* text-align: cente/r; */\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin: 10px 0;\n    color: #25231B;\n}\n\n.card_icons svg {\n    width: 18px;\n    height: 18px;\n}\n\n.cards_icon_world svg {\n    width: 30px !important;\n    height: 30px !important;\n}\n\n@media screen and (max-width:768px) {\n    .card_icons svg {\n        width: 14px;\n        height: 14px;\n    }\n}\n\n\n::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #D9DCB0;\n    /* Scrollbar thumb color */\n    border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #555;\n    /* Thumb hover color */\n    cursor: pointer;\n}\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    /* Track color */\n}\n\n/* For Firefox */\n* {\n    scrollbar-width: thin;\n    scrollbar-color: #D9DCB0 #f1f1f1;\n    /* Thumb and track colors */\n}\n\n\n.Toastify__toast-container {\n    font-family: 'Poppins', sans-serif;\n    max-width: 500px;\n}\n\n/* Customizing the toast notification */\n.Toastify__toast {\n    background-color: #ECE8CE !important;\n    color: #25231B !important;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Customizing the success toast */\n.Toastify__toast--success {\n    background-color: #ECE8CE !important;\n    color: #25231B !important;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n    border: 1px solid green !important;\n}\n\n/* Customizing the error toast */\n.Toastify__toast--error {\n    background-color: #ECE8CE !important;\n    color: #25231B !important;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n    border: 1px solid red !important;\n}\n\n\n\n\n\n.toast-success .toastify__toast-icon {\n    color: #25231B;\n    /* Set the desired color */\n}\n\n.input_divs .react-select__control {\n    height: 43px !important;\n    background: #ECE8CE !important;\n    border: none !important;\n}\n\n\n\n\n.crop-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    top: 80px;\n    width: 100%;\n    height: 100%;\n}\n\n.reactEasyCrop_Container {\n    height: 400px !important;\n}\n\n.controls {\n    position: absolute;\n    bottom: 80px;\n    left: 50%;\n    width: 50%;\n    transform: translateX(-50%);\n    height: 40px;\n    display: flex;\n    align-items: center;\n}\n\n.slider {\n    padding: 22px 0px;\n}\n\n.zoom-range {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    height: 2px;\n    border-top: 2px solid black;\n    border-bottom: 2px solid black;\n    background: #ECA45B;\n    width: 100%;\n}\n\n.zoom-range::-moz-range-thumb {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 1px solid #ECA45B;\n    background: #ECA45B;\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.zoom-range::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    border: 1px solid #ECA45B;\n    background: #ECA45B;\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n}\n\n.controls:hover input[type='range']::-webkit-slider-thumb {\n    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);\n    border-radius: 50%;\n}\n\n.controls:hover input[type='range']::-moz-range-thumb {\n    box-shadow: 0px 0px 0px 8px rgba(63, 81, 181, 0.16);\n}\n\n.thumb_nail_clip {\n    clip-path: polygon(0 0, 100% 0%, 100% 96%, 0 74%);\n}\n\n#react-select-12-placeholder {\n    color: #25231B !important;\n    font-family: \"Quicksand\", sans-serif !important;\n    font-weight: 700 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
